import { useMutation } from "@tanstack/react-query";
import { Timestamp } from "firebase/firestore";
import { invalidateImageFilesQueries } from "shared/queries/useImageFileQueries";
import { updateStudio } from "../api/updateStudio";
import { StudioUpdate } from "../types";
import { invalidateStudiosListQuery } from "./useStudiosListQuery";

type Params = {
  studio: StudioUpdate;
};

export const useUpdateStudioQuery = () => {
  return useMutation({
    mutationFn: async ({ studio }: Params) => {
      const studioData: StudioUpdate = {
        ...studio,
        updatedAt: Timestamp.now(),
      };

      return await updateStudio(String(studio.id), studioData);
    },
    onSuccess: (_, variables) => {
      invalidateStudiosListQuery();
      invalidateImageFilesQueries([
        ["studio-logo-file", (variables.studio?.id ?? "").toString()],
      ]);
    },
    onError: (e) => console.error(e),
  });
};
